
import React, { useState } from "react";
import { Box, Menu, MenuItem, Typography, Dialog, DialogTitle, DialogContent, DialogActions, alpha, Avatar, Chip, } from "@mui/material";
import ButtonComponent from "src/components/shared/Button";
import theme, { mobileTypography, typography } from "src/config/theme";
import { AssignedContainer, TaskCardContainer, CardContainer, CardHeader, InnerContainer, Title, Year_Gender, Title2, Dot, Line, InnerContainer2, Title3, SymptomsContainer, SymptomsText, CheapContainer, MenuContainer, HeaderPart, PagingContainer, Container2, InnerAppointments, InnerBox, Text1, Text2 } from "./Style";
import { ReactComponent as More } from '../../../../assets/images/more.svg';
import { ReactComponent as Profile } from '../../../../assets/images/profile-circle.svg';
import { ReactComponent as ArrowRight } from '../../../../assets/images/arrow-right 2.svg';
import { ReactComponent as Close } from '../../../../assets/images/close-circle.svg';
import useResponsive from "src/components/hooks/useResponsive";
import Paging from "src/components/App/Paging";
import { useNavigate } from 'react-router-dom';
const TaskCard = ({ data, page, perPage, setPage, totalCount }) => {
    const { isMobile, isDesktop, isTablet } = useResponsive();
    const Width = isMobile || isTablet ? '18px' : '24px';
    const Height = isMobile || isTablet ? '18px' : '24px';

    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [taskDetails, setTaskDetails] = useState(null);
    const navigate = useNavigate();
    const handleMenuOpen = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(item);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleViewDetails = (task) => {
        setTaskDetails(task);
        setShowDetails(true);
        handleMenuClose();
    };
    const actions = [
        { label: "View Details", icon: <Profile width={Width} height={Height} />, onClick: handleViewDetails },
        // { label: "Attend Now", icon: <ArrowRight />, onClick: () => navigate("/Patients") },
        // { label: "Cancel", icon: <Close />, onClick: () => handleOpen() }
    ];
    return (
        <>
            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>
                        {data.map((item, index) => {
                            return (
                                <TaskCardContainer key={index}>
                                    <CardHeader sx={{ height: 'auto', width: '100%', [theme.breakpoints.down('md')]: { width: '100%', height: 'auto', padding: '20px' } }}>

                                        <InnerContainer sx={{ height: 'auto', width: '100%' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                <Title>{item.name}</Title>
                                                <Box>{item.priority}</Box>
                                            </Box>
                                            <Title2>{item.dueDate}</Title2>

                                        </InnerContainer>
                                    </CardHeader>
                                    <Line />
                                    <AssignedContainer >
                                        <Title2 sx={{ display: 'flex', justifyContent: 'center !important' }}>{item.assignedTo}</Title2></AssignedContainer>
                                    <Line />
                                    <InnerContainer2 sx={{ [theme.breakpoints.down('md')]: { padding: '0 20px' }, padding: '10px 20px' }}>
                                        <Box>
                                            {item.taskStatus}
                                        </Box>

                                        <MenuContainer
                                            onClick={(event) => handleMenuOpen(event, item)}
                                            isActive={selectedRow === item}
                                        >
                                            <More />
                                        </MenuContainer>
                                    </InnerContainer2>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                        sx={{
                                            "& .MuiPaper-root": {
                                                width: "176px",
                                                borderRadius: "12px",
                                                padding: "4px 18px",
                                                backgroundColor: "red",
                                                border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                                backgroundColor: theme.palette.gery.white,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: '14px',
                                            }
                                        }}
                                    >
                                        {actions.map((action, index) => (
                                            <MenuItem key={index} onClick={() => {
                                                action.onClick(selectedRow);
                                                handleMenuClose();
                                            }}>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    {action.icon} <Typography>{action.label}</Typography>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </TaskCardContainer>
                            );
                        })}
                    </InnerBox>
                    <PagingContainer>


                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
            </Container2>

            {showDetails && (
                <Dialog open={showDetails} onClose={() => setShowDetails(false)}>

                    <HeaderPart>
                        Task Details
                        <Close width={Width} height={Height} onClick={() => setShowDetails(false)} style={{ cursor: 'pointer' }} />
                    </HeaderPart>
                    <DialogContent>
                        <Box sx={{ display: 'flex', justifyContent: 'flexStart', flexDirection: 'column', width: isMobile || isTablet ? '100%' : '332px' }}>
                            <Text1 >Name</Text1>
                            <Text2 mb={2} >{taskDetails.name}</Text2>
                            <Text1 >Description</Text1>
                            <Text2 mb={2} >{taskDetails.description}</Text2>
                            <Text1 >Assigned To</Text1>
                            <Text2 mb={2} >{taskDetails.assignedTo}</Text2>
                            <Text1 >Due Date</Text1>
                            <Text2 mb={2}  >{taskDetails.dueDate}</Text2>
                            <Text1 >{taskDetails.priority}</Text1>

                        </Box>

                    </DialogContent>
                    <DialogActions>
                        <ButtonComponent onClick={() => setShowDetails(false)} label="Close" />
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default TaskCard;

